<template>
  <div class="info-place pl-4 pr-4">
    <div class="flex border-b-default pb-2">
      <div class="w-full">
        <div class="mb-2">
          <smartP class="label text-black font-medium"> Request ID </smartP>
          <smartP class="content"> {{ gateway.id }} </smartP>
        </div>
        <div class="mb-2">
          <smartP class="label text-black font-medium"> Method </smartP>
          <smartP class="content"> {{ gateway.methods }} </smartP>
        </div>
        <div class="mb-2">
          <smartP class="label text-black font-medium"> URL </smartP>
          <smartP class="content"> {{ gateway.route }} </smartP>
        </div>
        <div class="mb-2" v-if="gateway.status != 500">
          <smartP class="label text-black font-medium"> Payload </smartP>
          <smartP class="content">  {{ gateway.payload }} </smartP>
        </div>
      </div>
      <div class="w-full">
        <div class="mb-2">
          <smartP class="label text-black font-medium"> Data </smartP>
          <smartP class="content"> {{ gateway.date }} </smartP>
        </div>
        <div class="mb-2">
          <smartP class="label text-black font-medium"> Status </smartP>
          <smartP class="content"> {{ gateway.status }} </smartP>
        </div>
      </div>
    </div>
    <div class="flex mt-4">
      <div class="w-full">
        <div>
          <label
            @click="modelDownload(gateway.id)"
            class="flex flex-row align-center cursor-pointer"
          >
            <SmartIcon
              :size="2"
              name="download"
              class="mr-1-2"
              style="color: #F1F3F4;"
            />
            <span
              class="font-medium text-blue"
            >
              Download
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import moment from 'moment';
import { downloadCsvFile } from 'utils/blob';

export default {
  name: 'InfoGateway',
  data() {
    return {

    };
  },
  props: {
    gateway: {
      type: Object,
      default: () => {}
    },
    gatewayDownloadFile: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    modelDownload(id) {
      const data = this.gatewayDownloadFile.find(gateway => gateway.id === id);
      const result = JSON.stringify(data);
      const currentDate = moment().format('MMMM Do YYYY, h:mm:ss a');
      downloadCsvFile({ filename: currentDate, file: result });
    }
  }
};
</script>

<style scoped>
</style>

<style lang="scss">
  .label,
  .content {
    font-size: $font-size-default;
    opacity: $font-opacity-hg;
  }
  .content {
    opacity: $font-opacity-md;
    text-overflow: ellipsis;
  }
  .situantion-p {
    padding: 0 0 0 $spacing-padding-xxsmall;
  }
  .text-blue {
    color: #367BF5;
  }
</style>
